import { Tab } from '@headlessui/react'
import { Fragment } from 'react'

import Link from '@/components/link'

const faqs = [
  {
    question: 'How do thrive skills help in making everyday emotions easy?',
    answer:
      'Each thrive skill has been designed to increase our awareness about our emotions in the context of the topic. In addition, they teach you methods to manage emotions constructively and effectively towards a goal using tools that are used regularly in psychotherapy. When you practise these methods regularly, they help you manage everyday emotions easily.',
  },
  {
    question: 'How much time do I need to spend to do well in this course?',
    answer:
      'The live sessions will need 45mins once a week for 4 weeks. In addition, we recommend you spend 10 minutes per day to practise the learnings in real life.',
  },
  {
    question: 'Is the course in English or Hindi or other Indian languages?',
    answer: 'Currently we are offering this course in English only.',
  },
]

const Faq = () => {
  return (
    <Tab.Panel as='dl' className='text-sm text-gray-500'>
      <>
        {faqs.map((faq) => (
          <Fragment key={faq.question}>
            <dt className='custom-font-24 question mt-10 text-gray-900'>
              {faq.question}
            </dt>
            <dd className='answer prose prose-sm mt-2 max-w-none text-gray-500 '>
              <p className='custom-font-24'>{faq.answer}</p>
            </dd>
          </Fragment>
        ))}
        <p className='underline-custom mt-10'>
          <Link
            href='../FAQ'
            className='custom-font-24 translate-y-0.5 font-bold capitalize text-theme-blue-gray hover:no-underline'
          >
            know more
          </Link>
        </p>
      </>
      <style jsx>{`
        .underline-custom::before {
          content: '';
          width: calc(77px + (125 - 77) * (100vw - 375px) / (1920 - 375));
          height: 1px;
          background-color: #4b5563;
          position: absolute;
          margin-top: calc(16px + (33 - 16) * (100vw - 375px) / (1920 - 375));
        }
        .question {
          font-weight: 400;
        }
        .answer {
          font-weight: 300;
        }
      `}</style>
    </Tab.Panel>
  )
}

export default Faq
